import React from "react";
import { Navigate } from "react-big-calendar";

// Use the library's own constants to ensure compatibility
const NAV_KEYS = [Navigate.PREVIOUS, Navigate.TODAY, Navigate.NEXT] as const;

// Map Navigate constants to display symbols
const navigate = {
	[Navigate.PREVIOUS]: "<",
	[Navigate.TODAY]: "•",
	[Navigate.NEXT]: ">",
};

interface CalendarToolbarProps {
	onNavigate: (action: string) => void;
	TitleComp?: React.ComponentType;
	viewCounts?: number | undefined;
	onView: (view: string) => void;
	date: Date;
}

export default function CalendarToolbar({
	onNavigate,
	viewCounts,
	TitleComp,
	onView: _,
	date,
	...props
}: CalendarToolbarProps): React.JSX.Element {
	// Use custom onNavigate if provided, otherwise use the default one
	const handleNavigate = (action: string) => {
		onNavigate(action);
	};
	let nextDate = date.getTime() + ((viewCounts || 7) - 1) * 86400000;
	const label = `${date.toLocaleDateString("en-IN", { day: "numeric" })} - ${new Date(nextDate).toLocaleDateString("en-IN", { day: "numeric" })} ${new Date(nextDate).toLocaleDateString("en-IN", { month: "short" })}`;
	return (
		<div className="flex gap-2 my-2 w-full justify-between items-center" {...props}>
			<div className="text-md font-medium text-gray-900">{label}</div>
			<div className="inline-flex" role="group">
				{NAV_KEYS.map((el, index) => (
					<button
						key={el}
						onClick={() => {
							handleNavigate(el);
						}}
						className={`text-gray-700 px-3 py-0.5 text-xl hover:text-primary focus:outline-none transition-colors duration-150 ${
							index === 0 ? "rounded-l-md!" : "rounded-none"
						} ${index === NAV_KEYS.length - 1 ? "rounded-r-md" : ""} ${index > 0 ? "-ml-px" : ""}`}
						type="button"
					>
						<span>{navigate[el]}</span>
					</button>
				))}
			</div>
			{TitleComp && (
				<div className="flex justify-center sm:justify-start">
					<TitleComp />
				</div>
			)}
		</div>
	);
}
